import React from 'react';
import '../../css/cards/MaterItem.css';

import { IoPlay } from 'react-icons/io5';

import blender from '../../images/technologies/blender.png';
import zbrush from '../../images/technologies/zbrush.png';
import substance from '../../images/technologies/substance.png';

import Image from 'react-image-webp';

import { openVideo } from '../../features/video';
import { useDispatch } from 'react-redux';

const MasterItem = ({ content }) => {
	const dispatch = useDispatch();

	const softwareLogo = (img) => {
		if (img === 'blender') return blender;
		if (img === 'zbrush') return zbrush;
		if (img === 'substance') return substance;
	};

	return (
		<div className='MasterItem'>
			<div className='item-header'>
				<div
					className='item-play'
					onClick={() => {
						// handleOpenModal(true);
						dispatch(
							openVideo({
								modal: true,
								url: 'https://www.youtube.com/watch?v=Qrw5QGFsUsY&t=1s&ab_channel=LIBELACADEMY',
								type: 'common',
							})
						);
					}}
				>
					<IoPlay />
				</div>
				<h1 className='item-id'>{content.id}</h1>
				<div className='item-filter'></div>
				<Image webp={content.imageWebp} src={content.image} className='item-image' />
			</div>
			<div className='item-content'>
				<div className='item-information'>
					<h2 className='item-title'>{content.title}</h2>
					<p className='item-desc'>{content.description}</p>
				</div>
				<div className='item-blender'>
					{content.software.map((img, index) => (
						<img
							key={index}
							src={softwareLogo(img)}
							alt='software'
							style={{ margin: '0px 10px' }}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default MasterItem;
